import React, { useState, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import useStyles from "./style/style";
import Typography from "@material-ui/core/Typography";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { storage, useFirebase } from "../../../components/firebase/FirebaseProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import { simplerDateTime } from "../../../utils/dateTime";
import defaultLogo from "../../../assets/images/landing-image-third.png";
import defaultCover from "../../../assets/images/defaultcover.png";
import { Divider, Menu, MenuItem } from "@material-ui/core";

function HeaderToko({
  nama,
  level,
  logo,
  cover,
  background,
  created_at,
  totalOrder,
  openDialog,
  ...props
}) {
  const classes = useStyles();

  const { profil, webstore } = useData();
  const { user } = useFirebase();

  const history = useHistory();

  const [form, setForm] = useState({
    urlCover: "",
    ulrLogo: "",
  });

  const [error, setError] = useState({
    urlCover: "",
    ulrLogo: "",
  });

  const [isSubmitting, setSubmitting] = useState(false);

  const [pengunjung, setpengunjung] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState(false);

  const bergabung = useMemo(() => {
    if (
      created_at &&
      typeof created_at.seconds === "number" &&
      typeof created_at.nanoseconds === "number"
    ) {
      return simplerDateTime(created_at.toDate());
    }

    return "Tidak diketahui";
  }, [created_at]);

  const handleChanegCover = async (e) => {
    const file = e.target.files[0];

    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setError((error) => ({
        ...error,
        urlCover: `Tipe file tidak didukung: ${file.type}`,
      }));
    } else if (file.size >= 512000) {
      setError((error) => ({
        ...error,
        urlCover: `Ukuran file terlalu besar > 500KB`,
      }));
    } else {
      const reader = new FileReader();

      reader.onabort = () => {
        setError((error) => ({
          ...error,
          urlCover: `Proses pembacaan file dibatalkan`,
        }));
      };

      reader.onerror = () => {
        setError((error) => ({
          ...error,
          urlCover: "File tidak bisa dibaca",
        }));
      };

      reader.onload = async () => {
        setError((error) => ({
          ...error,
          urlCover: "",
        }));
        setSubmitting(true);
        try {
          const storageRef = storage.ref();

          const urlExt = file.name.substring(file.name.lastIndexOf("."));

          const urlRef = await storageRef.child(`webstore/${Date.now()}_${user?.uid}_${urlExt}`);

          const urlSnapshot = await urlRef.putString(reader.result, "data_url");

          const urlUrl = await urlSnapshot.ref.getDownloadURL();

          setForm((currentForm) => ({
            ...currentForm,
            urlCover: urlUrl,
          }));

          //   if (urlUrl) {
          //     let field;
          //     switch (changeType) {
          //         case 'cover':
          //             field = { cover: urlUrl }
          //             break;
          //         default:
          //             field = { logo: urlUrl };
          //             break;
          //     }
          //     props.webstoreRef.update(field)
          // }
          props.webstoreRef.update({ cover: urlUrl });

          // setSomethingChange(true);
        } catch (e) {
          setError((error) => ({
            ...error,
            urlCover: e.message,
          }));
        }

        setSubmitting(false);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleChangeLogo = async (e) => {
    const file = e.target.files[0];

    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setError((error) => ({
        ...error,
        ulrLogo: `Tipe file tidak didukung: ${file.type}`,
      }));
    } else if (file.size >= 512000) {
      setError((error) => ({
        ...error,
        ulrLogo: `Ukuran file terlalu besar > 500KB`,
      }));
    } else {
      const reader = new FileReader();

      reader.onabort = () => {
        setError((error) => ({
          ...error,
          ulrLogo: `Proses pembacaan file dibatalkan`,
        }));
      };

      reader.onerror = () => {
        setError((error) => ({
          ...error,
          ulrLogo: "File tidak bisa dibaca",
        }));
      };

      reader.onload = async () => {
        setError((error) => ({
          ...error,
          ulrLogo: "",
        }));
        setSubmitting(true);
        try {
          const storageRef = storage.ref();

          const urlExt = file.name.substring(file.name.lastIndexOf("."));

          const urlRef = await storageRef.child(`products/${urlExt}`);

          const urlSnapshot = await urlRef.putString(reader.result, "data_url");

          const urlUrl = await urlSnapshot.ref.getDownloadURL();

          setForm((currentForm) => ({
            ...currentForm,
            ulrLogo: urlUrl,
          }));

          //   if (urlUrl) {
          //     let field;
          //     switch (changeType) {
          //         case 'cover':
          //             field = { cover: urlUrl }
          //             break;
          //         default:
          //             field = { logo: urlUrl };
          //             break;
          //     }
          //     props.webstoreRef.update(field)
          // }
          props.webstoreRef.update({ logo: urlUrl });

          // setSomethingChange(true);
        } catch (e) {
          setError((error) => ({
            ...error,
            ulrLogo: e.message,
          }));
        }

        setSubmitting(false);
      };

      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (profil?.id) {
      const getPengunjung = firefunctions.httpsCallable("getDailyVisitors");

      getPengunjung({ user_id: profil.id })
        .then((res) => {
          setpengunjung(res?.data?.[0]?.jumlah?.toString());
        })
        .catch((err) => console.log("Error CF getDailyVisitors : ", err));
    }
  }, [profil]);

  return (
    <>
      <div className={classes.wrapHeader}>
        <div style={{ height: 300 }}>
          {/* <label htmlFor="cover"> */}
          <img
            className={classes.img}
            src={!cover ? defaultCover : cover}
            title="Cover"
            alt="banner"
          />
          {/* </label> */}
          {/* <input
            style={{ display: "none" }}
            type="file"
            id="cover"
            onChange={handleChanegCover}
          /> */}
        </div>
        <div className={classes.wrapHeaderToko}>
          <div className={classes.wrapAvatar}>
            {/* <label htmlFor="logo"> */}
            <Avatar
              alt={nama}
              className={classes.large}
              src={!logo ? defaultLogo : logo}
              title="Logo"
            />
            {/* </label> */}
            {/* <input
              style={{ display: "none" }}
              type="file"
              id="logo"
              onChange={handleChangeLogo}
            /> */}
          </div>
          <div className={classes.wrapDetail}>
            <Typography variant="h6" className={classes.liquidTitle}>
              {nama}
            </Typography>
            <div>
              <div style={{ display: "flex" }}>
                <Typography className={classes.liquidLabel}>Level :</Typography>
                <Typography className={classes.liquidValue}>{level}</Typography>
              </div>
              <div style={{ display: "flex" }}>
                <Typography className={classes.liquidLabel}>
                  Bergabung :
                </Typography>
                <Typography className={classes.liquidValue}>
                  {bergabung}
                </Typography>
              </div>
              <div style={{ display: "flex" }}>
                <Typography className={classes.liquidLabel}>
                  Pengunjung :
                </Typography>
                <Typography className={classes.liquidValue}>
                  {pengunjung ? pengunjung : "-"}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "10px",
            paddingBottom: "5px",
          }}
        >
          <div>
            <Typography style={{ fontSize: "15px", color: "gray" }}>
              {webstore?.products?.length > 0 ? webstore?.products?.length : 0}{" "}
              Produk ditoko
            </Typography>
          </div>
          <div
            onClick={handleClick}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <StorefrontIcon />
            <Typography style={{ fontSize: "15px", marginLeft: "5px" }}>
              Setting Toko
            </Typography>
          </div>
        </div>
        <Divider style={{ marginTop: "5px", marginBottom: "15px" }} />
        {/* <div style={{ display: "flex", justifyContent: "space-around", marginTop:"-4px" }}>
        <label htmlFor="cover" style={{ flexGrow: 1 }}>
          <div>
            <div
              className={classes.btnHeader}
            >
              <IconButton color="primary" component="span">
                <HomeOutlinedIcon />
              </IconButton>
              <Typography className={classes.liquidButton}>
                Ganti Cover Toko
              </Typography>
            </div>
          </div>
        </label>
        <input
          style={{ display: "none" }}
          type="file"
          id="cover"
          onChange={handleChanegCover}
        />
        <Divider orientation="vertical" flexItem />
        <div style={{ flexGrow: 1 }} onClick={openDialog}>
          <div
            className={classes.btnHeader}
          >
            <IconButton color="primary" onClick={openDialog}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
            <Typography className={classes.liquidButton}>
              Hapus Semua Produk
            </Typography>
          </div>
        </div>
        <Divider orientation="vertical" flexItem />
        <div
          style={{ flexGrow: 1 }}
          onClick={() => history.push("/tokosaya/promo")}
        >
          <div
            className={classes.btnHeader}
          >
            <IconButton
              color="primary"
              onClick={() => history.push("/tokosaya/promo")}
            >
              <PostAddIcon />
            </IconButton>
            <Typography className={classes.liquidButton}>
              Promo Toko
            </Typography>
          </div>
        </div>
      </div> */}
        {/* <Divider /> */}
      </div>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => history.push("/tokosaya/pilih")}>
          <Typography style={{ fontSize: "12px" }}>Tambah Produk</Typography>
        </MenuItem>
        <MenuItem onClick={() => history.push("/tokosaya/promo")}>
          <Typography style={{ fontSize: "12px" }}>
            Tambah Diskon Toko
          </Typography>
        </MenuItem>
        <MenuItem onClick={openDialog}>
          <Typography style={{ fontSize: "12px" }}>
            hapus Semua Produk
          </Typography>
        </MenuItem>
        <label htmlFor="cover" style={{ flexGrow: 1 }}>
          <MenuItem>
            <Typography style={{ fontSize: "12px" }}>
              Ganti Cover Toko
            </Typography>
          </MenuItem>
        </label>
        <input
          style={{ display: "none" }}
          type="file"
          id="cover"
          onChange={handleChanegCover}
        />
        <label htmlFor="logo" style={{ flexGrow: 1 }}>
          <MenuItem>
            <Typography style={{ fontSize: "12px" }}>
              Ganti Foto Profil
            </Typography>
          </MenuItem>
        </label>
        <input
          style={{ display: "none" }}
          type="file"
          id="logo"
          onChange={handleChangeLogo}
        />
      </Menu>
    </>
  );
}

export default HeaderToko;
